/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum OsisRuleOrderValue {
    BrandAndMarket = 'BrandAndMarket',
    Description = 'Description',
    FareTypes = 'FareTypes',
    MarketingCarriers = 'MarketingCarriers',
    Osis = 'Osis'
}

export function OsisRuleOrderValueFromJSON(json: any): OsisRuleOrderValue {
    return OsisRuleOrderValueFromJSONTyped(json, false);
}

export function OsisRuleOrderValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): OsisRuleOrderValue {
    return json as OsisRuleOrderValue;
}

export function OsisRuleOrderValueToJSON(value?: OsisRuleOrderValue | null): any {
    return value as any;
}

